// extracted by mini-css-extract-plugin
export default {"deviceButton":"WhiteboardButton_deviceButton__yDWou","icon":"WhiteboardButton_icon__shcmu"};